<div class="details-layout flex flex-col w-full gap-6 lg:flex-row lg:items-start lg:gap-8">
  <div class="details-panel details-panel--left w-full min-w-0 lg:max-w-[20rem] lg:flex-[0_0_28%]">
    <div class="details-card details-card--files rounded-xl border border-[var(--border-neutral)] bg-[var(--header-panel-bg)] p-4 shadow-[var(--shadow-card)] md:p-5">
      <div class="details-card__title-row mb-4 flex flex-wrap items-baseline gap-2">
        <h3 class="details-card__title m-0 p-0 text-base font-semibold text-[var(--title-color-1)]">
          Version Files
        </h3>
      </div>

      @if (listLoading()) {
        <app-skeleton variant="list-items" [count]="4" />
      } @else if (versionFiles().length > 0) {
        <div class="details-file-list flex max-h-[20rem] flex-col gap-1 overflow-y-auto overflow-x-hidden">
          @for (file of versionFiles(); track file.name) {
            <button
              type="button"
              class="details-file-item flex w-full cursor-pointer items-center gap-3 rounded-lg border border-transparent bg-[var(--header-panel-bg)] px-3 py-2 text-left font-[inherit] transition-colors"
              [class.details-file-item--selected]="selectedFileName() === file.name"
              (click)="onFileSelect(file)"
            >
              <img
                class="details-file-item__icon h-5 w-5 shrink-0"
                src="/icons/file-document.svg"
                width="20"
                height="20"
                alt=""
              />
              <span class="details-file-item__name min-w-0 flex-1 truncate text-sm">{{ file.name }}</span>
            </button>
          }
        </div>
      } @else {
        <p class="details-empty m-0 px-0 py-4 text-[0.9375rem] text-[var(--text-muted-on-light)]">No files</p>
      }
    </div>
  </div>

  <div class="details-panel details-panel--right min-w-0 flex-1">
    <div class="details-preview rounded-xl border border-[var(--border-neutral)] bg-[var(--header-panel-bg)] p-4 shadow-[var(--shadow-card)] md:p-5 xl:p-8">
      <h3 class="details-preview__title m-0 mb-4 p-0 text-base font-semibold text-[var(--title-color-1)] md:mb-5 md:text-lg">
        Dataset Preview
        @if (selectedFileName(); as name) {
          <span class="details-preview__file-name ml-1 font-semibold text-[var(--primary-color)]">for {{ name }}</span>
        }
      </h3>

      @if (selectedFileName()) {
        <div class="details-preview__meta mb-4 flex flex-row flex-wrap gap-x-4 gap-y-2">
          @if (selectedFileSize()) {
            <div class="details-preview__meta-row flex flex-row gap-1 text-sm">
              <span class="details-preview__meta-label font-medium text-[var(--text-muted-on-light)]">File size</span>
              <span class="details-preview__meta-value font-medium text-[var(--text-primary-on-light)]">{{ selectedFileSize() }}</span>
            </div>
          }
          @if (selectedFileLastUpdated()) {
            <div class="details-preview__meta-row flex flex-row gap-1 text-sm">
              <span class="details-preview__meta-label font-medium text-[var(--text-muted-on-light)]">Last updated</span>
              <span class="details-preview__meta-value font-medium text-[var(--text-primary-on-light)]">{{ selectedFileLastUpdated() }}</span>
            </div>
          }
          @if (license()) {
            <div class="details-preview__meta-row flex flex-row gap-1 text-sm">
              <span class="details-preview__meta-label font-medium text-[var(--text-muted-on-light)]">License</span>
              <span class="details-preview__meta-value font-medium text-[var(--text-primary-on-light)]">{{ license() }}</span>
            </div>
          }
        </div>
      }

      @if (listLoading() || previewLoading()) {
        <app-skeleton variant="table" />
      } @else if (hasPreviewData()) {
        <div class="details-preview__separator mb-4 h-px w-full bg-[var(--border-neutral)]"></div>
        <div class="details-table-wrap max-w-full overflow-x-auto rounded-lg border border-[var(--border-neutral)]">
          <div class="details-table-container min-w-full">
            <table class="details-table w-full border-collapse text-sm">
              <thead class="sticky top-0 z-[1] bg-[var(--surface-subtle)]">
                <tr>
                  @for (header of previewHeaders(); track header) {
                    <th
                      class="whitespace-nowrap border-b-2 border-[var(--border-neutral)] px-4 py-3 text-left text-[0.8125rem] font-semibold uppercase tracking-wide text-[var(--text-secondary-on-light)]"
                    >
                      {{ header }}
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (entry of displayedEntries(); track $index) {
                  <tr class="border-b border-[var(--border-neutral)] transition-colors last:border-b-0 hover:bg-[var(--surface-subtle)]">
                    @for (header of previewHeaders(); track header) {
                      <td
                        class="max-w-[12.5rem] overflow-hidden text-ellipsis whitespace-nowrap px-4 py-3 leading-normal text-[var(--text-primary-on-light)]"
                      >
                        {{ getCellValue(entry, header) }}
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      } @else if (selectedFileName() && !previewLoading()) {
        <div class="details-empty details-empty--preview px-4 py-8 text-center text-[var(--text-muted-on-light)]">
          No preview available for this file.
        </div>
      } @else if (!selectedFileName() && !listLoading() && versionFiles().length > 0) {
        <div class="details-empty details-empty--preview px-4 py-8 text-center text-[var(--text-muted-on-light)]">
          Select a file from the list to preview.
        </div>
      }
    </div>
  </div>
</div>
